function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-130"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.02,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.14,
    y: 390.92,
    width: 43.55,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 389.21,
    width: 48.56,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.61,
    y: 392.59,
    width: 34.29,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.46,
    y: 392.59,
    width: 7.44,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.8,
    y: 392.59,
    width: 48.57,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.62,
    y: 396.81,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.45,
    y: 78,
    width: 200.95,
    height: 144.26,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.33 222.26 159.79 78 198.15 78 163.69 222.26 125.33 222.26",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.25 222.26 234.71 78 248.7 78 214.24 222.26 200.25 222.26",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.09 222.26 146.56 78 151.81 78 117.34 222.26 112.09 222.26",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282,73H61.86a.89.89,0,0,0-.89.89h0a.89.89,0,0,0,.89.89H282a.89.89,0,0,0,.89-.89h0A.89.89,0,0,0,282,73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.52,
    y: 77.69,
    width: 8.57,
    height: 144.88,
    transform: "translate(345.62 300.25) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.1,
    y: 77.69,
    width: 0.96,
    height: 144.88,
    transform: "translate(355.15 300.25) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.73,
    y: 48.26,
    width: 2.38,
    height: 203.73,
    transform: "translate(21.79 322.05) rotate(-90)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.79,221.27h0V76.61H70.06V221.27h0v2.38H273.79Zm-201.35,0V79h199V221.27Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.79,
    y: 76.61,
    width: 1.19,
    height: 147.04,
    transform: "translate(548.77 300.26) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.34 70.85 238.34 310.45 288.57 310.45 279.36 70.85 238.34 70.85",
    style: {
      fill: "#ebebeb",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.48 70.85 203.48 310.45 253.71 310.45 244.5 70.85 203.48 70.85",
    style: {
      fill: "#ebebeb",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.37 70.86 87.37 310.45 56.47 310.45 62.13 70.86 87.37 70.86",
    style: {
      fill: "#ebebeb",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.81 70.86 108.81 310.45 77.91 310.45 83.58 70.86 108.81 70.86",
    style: {
      fill: "#ebebeb",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.41,
    y: 261.46,
    width: 35.83,
    height: 120.94,
    transform: "translate(286.64 643.86) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.37 382.4 125.41 382.4 125.41 371.52 137.62 371.52 131.37 382.4",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.22,
    y: 261.46,
    width: 35.83,
    height: 120.94,
    transform: "translate(578.26 643.86) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.41,
    y: 261.46,
    width: 151.01,
    height: 116.76,
    transform: "translate(401.83 639.68) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.03,
    y: 266.64,
    width: 141.76,
    height: 32.02,
    transform: "translate(401.83 565.29) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.22,276.59h13.39c5.82,0,11.38-3.95,15.38-10.93H178.84C182.84,272.64,188.4,276.59,194.22,276.59Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.46 382.4 276.42 382.4 276.42 371.52 264.21 371.52 270.46 382.4",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.03,
    y: 303.83,
    width: 141.76,
    height: 32.02,
    transform: "translate(401.83 639.68) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.22,313.78h13.39c5.82,0,11.38-3.95,15.38-10.92H178.84C182.84,309.83,188.4,313.78,194.22,313.78Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.03,
    y: 341.02,
    width: 141.76,
    height: 32.02,
    transform: "translate(401.83 714.07) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.22,351h13.39c5.82,0,11.38-4,15.38-10.93H178.84C182.84,347,188.4,351,194.22,351Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.24,239.47c-2.31-23.94-3.92-62.79-2.67-75.79a1.65,1.65,0,0,1,.65-1.13h0a1.6,1.6,0,0,1,2.54,1.34c-.22,6.44-.47,22.54.9,50.3.68,13.82,1.67,23.29,1,25.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.62,188c-5.28-6.79-16.2-12.16-27.39-13-4.4-.33,13.25,8.44,20.52,17.19,5.64,6.79,11.95,18,14.06,24.09C219.58,203.66,218.9,194.77,213.62,188Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.67,186.51c5.47-7.61,18.08-13.46,31.73-14.12,5.36-.26-15,9.29-22.64,19.07-5.91,7.61-12,20.2-13.63,27.11C219.73,204.24,219.21,194.12,224.67,186.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214,165.59c-4.17-5.67-13.37-10.32-23.13-11.28-3.83-.37,11.05,7.22,16.82,14.53,4.49,5.68,9.26,15,10.69,20C218.14,178.53,218.15,171.26,214,165.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.38,166.75c4.63-6.44,15.31-11.4,26.86-12,4.54-.22-12.72,7.87-19.16,16.16-5,6.43-10.14,17.1-11.55,23C218.19,181.76,217.75,173.2,222.38,166.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.78,213.55c-3-4.28-9.78-7.87-17-8.73-2.84-.33,8.1,5.53,12.28,11.05a53.81,53.81,0,0,1,7.64,15C219.67,223.22,219.79,217.83,216.78,213.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.25,211.14c2.62-4.24,9.09-7.82,16.3-8.68,2.84-.34-7.62,5.49-11.29,11A47.23,47.23,0,0,0,221,228.32C220.29,220.73,219.64,215.39,222.25,211.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.22,261.46h0c-5.76,0-10.52-1.2-10.85-6.95l-1-16.63H233l-1,16.63C231.74,260.26,227,261.46,221.22,261.46Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.89,241.66H209.54A1.86,1.86,0,0,1,207.7,240l-.36-3.2a1.86,1.86,0,0,1,1.85-2.06h24.06a1.86,1.86,0,0,1,1.84,2.06l-.35,3.2A1.86,1.86,0,0,1,232.89,241.66Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-130"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-130",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-130"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 298.16,
    y: 103.6,
    width: 118.78,
    height: 312.64,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.16,
    y: 103.6,
    width: 118.78,
    height: 312.64,
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M419.77,144.14c-4.34.42-6.23,1.06-8-1.45s-8.33-3.05-10.52-.3-3,4.56-7.89,3.84-6.54.57-7.3,2.6-12,2.76-8.78,5L419,147.7S424.11,143.72,419.77,144.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.26,122.32c-1.34-1.41-5.29-1.36-8.86.41s-1-6.41-7.63-4.12c-9.51,3.27-7,8.48-10.94,8.55s-15.51,3.15-9.47,5l35-5.15S383.61,123.72,382.26,122.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.36,177.23c-.95-1-3.75-1-6.29.3s-.69-4.55-5.41-2.93c-6.75,2.32-5,6-7.76,6.07s-11,2.23-6.72,3.58L335,180.59S337.32,178.23,336.36,177.23Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M403.08,354V365.8a1.8,1.8,0,0,1-1.79,1.8h-3.23a1.79,1.79,0,0,0-1.8,1.79v2.26a1.8,1.8,0,0,1-1.8,1.8h-12a1.81,1.81,0,0,1-1.8-1.8V354a1.79,1.79,0,0,0-1.79-1.79H377a1.81,1.81,0,0,1-1.8-1.8V330.1a1.79,1.79,0,0,0-1.79-1.79H369.9a1.8,1.8,0,0,0-1.8,1.79v12.61a1.45,1.45,0,0,1-1.52,1.36h0a1.44,1.44,0,0,1-1.51-1.36V305.17a1.8,1.8,0,0,0-1.8-1.8h-3.54a1.79,1.79,0,0,0-1.79,1.8v37.1a1.8,1.8,0,0,1-1.8,1.8h-.43a1.8,1.8,0,0,1-1.8-1.8V323.09a1.75,1.75,0,0,0-.19-.81l-10.67-21.36a1.74,1.74,0,0,1-.19-.8V273.17a1.79,1.79,0,0,0-1.8-1.79H330.67a1.8,1.8,0,0,0-1.8,1.79v69.1a1.79,1.79,0,0,1-1.79,1.8h-.73a1.79,1.79,0,0,1-1.79-1.8V316a1.81,1.81,0,0,0-1.8-1.8H312.37a1.81,1.81,0,0,0-1.8,1.8v26.28a1.79,1.79,0,0,1-1.79,1.8h-1.41a1.8,1.8,0,0,0-1.8,1.8v4.52a1.8,1.8,0,0,1-1.79,1.8h-.5a1.79,1.79,0,0,0-1.8,1.79v35.93a1.79,1.79,0,0,0,1.8,1.79H408.42a1.79,1.79,0,0,0,1.79-1.79V354a1.79,1.79,0,0,0-1.79-1.79h-3.54A1.8,1.8,0,0,0,403.08,354Z",
    style: {
      fill: "#407BFF",
      opacity: 0.07
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.16,
    y: 395.01,
    width: 118.44,
    height: 10.48,
    style: {
      fill: "#407BFF",
      opacity: 0.07
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "428.32 94.92 428.32 416.24 415.3 416.24 415.3 109.26 310.93 109.26 310.93 416.24 297.92 416.24 297.92 94.92 428.32 94.92",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "422.53 94.92 422.53 416.24 409.52 416.24 409.52 109.26 305.15 109.26 305.15 416.24 292.13 416.24 292.13 94.92 422.53 94.92",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,133.54c-4.47.36-10.3,3.43,2.74,7s14.8-.29,14.8-.29S337,132.57,325,133.54Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,133.54c-4.47.36-10.3,3.43,2.74,7s14.8-.29,14.8-.29S337,132.57,325,133.54Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 347.45,
    cy: 159.37,
    rx: 5.38,
    ry: 6.54,
    transform: "matrix(0.99, -0.15, 0.15, 0.99, -20.04, 54.15)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 330.22,
    cy: 144.06,
    rx: 5.38,
    ry: 6.54,
    transform: "matrix(0.99, -0.15, 0.15, 0.99, -17.93, 51.38)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.52,345.61v27.8c-14.45-11.41-29.23-24.18-32.3-30.83-11.12-24.16-32.46-87.51-32.46-87.51l33.6-13.74.15.68c.88,4.09,5.59,26.47,11.12,60.75,1.48,9.15,3,19.16,4.55,29.89C396.84,334.39,402.59,339.34,409.52,345.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.06,311.8c-1.75-11.23-3.44-21.36-5-30.22l-7.68-5.9A150.85,150.85,0,0,0,391.06,311.8Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.52,276.68V334.6c-2-3.34-3.87-6.35-5.51-8.9-3.8-5.92-8.92-14.12-14.38-22.94C374.72,278.71,357.29,250,357.29,250l21.22-8,9.93-3.74C397.05,249.58,402.76,261.36,409.52,276.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.41,198.06c-.7.51-1.23.88-1.83,1.28s-1.17.76-1.75,1.13c-1.18.73-2.36,1.43-3.56,2.11a79.1,79.1,0,0,1-7.38,3.66c-1.25.57-2.54,1.07-3.82,1.59s-2.59,1-3.92,1.37a73,73,0,0,1-8.1,2.14l-.39.08a5.41,5.41,0,0,1-4.26-.85,47.29,47.29,0,0,1-7.23-6.39,85.1,85.1,0,0,1-5.82-6.93q-2.67-3.57-5-7.28c-1.57-2.5-3.05-5-4.42-7.66a3.3,3.3,0,0,1,5.35-3.74l.07.07c1.86,2,3.78,4.12,5.7,6.13s3.85,4,5.82,5.93,4,3.77,6,5.47a43.91,43.91,0,0,0,6,4.37l-4.66-.77c2.24-.73,4.46-1.5,6.66-2.42s4.38-1.89,6.53-3,4.27-2.2,6.36-3.4c1-.59,2.08-1.2,3.09-1.82l1.5-.95,1.38-.88.28-.18a6.6,6.6,0,0,1,7.43,10.9Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.85,181.83a192,192,0,0,0-22.77,11.44c2.33,6.73,5.57,14.74,10.8,19.42a104.11,104.11,0,0,0,13.23-10C347.24,194.83,346.39,178,336.85,181.83Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.27,254.91c1.74,6,3,12.89,5.72,14.22s8.92-7.78,11.27-11.21c6.39.48,25.07-2.05,30.79-5.73s3.92-8.19-.66-14.52C377.85,236.41,350.68,250.33,343.27,254.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.43,174.12a134.76,134.76,0,0,0-26.51,7.43c-9.23,3.73-14,11.24-12.34,21.06,2,11.8,11,39.28,19.47,58,1.47,3.22,45.77-16.9,47.91-21.33-3.49-12.25-12.57-23.92-16.09-53.18C375.15,180.07,369.34,173.1,363.43,174.12Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.6,197.28a53.38,53.38,0,0,1,8.95-3.25.94.94,0,0,1,1.14.59c.34.92.94,2.47,1.54,3.84a.94.94,0,0,1-.59,1.29c-2.34.71-6.16,2.11-8.6,3.17a1,1,0,0,1-1.18-.38,13.67,13.67,0,0,1-1.74-4.2A.94.94,0,0,1,354.6,197.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.63,193.73c.14.83-.09,1.56-.53,1.64s-.92-.53-1.07-1.36.09-1.56.53-1.64S342.48,192.9,342.63,193.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.67,182.13c2.43,1.42,4.66,2.85,6.93,4.36s4.47,3,6.65,4.65,4.35,3.23,6.48,4.93,4.21,3.44,6.28,5.23l.36.31a5.42,5.42,0,0,1,1.87,3.85,32.69,32.69,0,0,1-.95,9,47.72,47.72,0,0,1-2.7,7.93,62.09,62.09,0,0,1-3.72,7.16,57.52,57.52,0,0,1-4.61,6.59,3.3,3.3,0,0,1-5.62-3.29l.08-.18c.84-2.14,1.73-4.48,2.48-6.73s1.46-4.54,2-6.8a49.55,49.55,0,0,0,1.21-6.64,25.15,25.15,0,0,0-.05-6l2.23,4.16c-4.19-3-8.48-5.89-12.81-8.75l-13-8.48-.07,0a6.6,6.6,0,0,1,6.94-11.23Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.61,175.18a190.55,190.55,0,0,1,21.27,14,40.26,40.26,0,0,1-13.56,15.44s-4.12-1-11.41-8.9C357.77,186.87,360.58,170.26,369.61,175.18Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.47,230.87l-5.77,6.6,9.43,4.72s4.51-6.64,1.43-9.72Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.17,246.74l3.57,1.09a2.93,2.93,0,0,0,3.54-1.62l1.85-4-9.43-4.72-1.6,5.36A3.15,3.15,0,0,0,383.17,246.74Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342,188.42s4.81,3.09,5.27,7.14c11.47-8.45,13.3-16.74,10.8-20.39a4.91,4.91,0,0,0-3.49,0S351.06,182.39,342,188.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342,188.42s-3.33,3.88-3.69,7.91c-7.34-3.3-4.68-11.91-2.7-14.2a14.06,14.06,0,0,1,4.15-2.07S337.11,183.37,342,188.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.9,155.6c.57,5.65,2.31,15.2,6.45,19.36a3.15,3.15,0,0,1,.46,3.87,20.51,20.51,0,0,1-11.3,9.29c-5.39,1.8-6.87-.76-6.8-3.5a4.62,4.62,0,0,1,1.88-3.55c4.68-3.53,3-8.07.63-12.11Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.37,161.05,339.23,169a20.24,20.24,0,0,1,1.6,3.19c2.5-1.15,5.22-5.05,4.67-7.85A9.58,9.58,0,0,0,344.37,161.05Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.31,146.23c.75,8.66,1.63,13.69-2,18.81-5.46,7.71-16.49,5.55-19.79-2.67-3-7.4-3.69-20.33,4.1-25.14A11.53,11.53,0,0,1,349.31,146.23Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.3,134.49c-4.87.48-7.19,3.37-5.92,4.81-4.29.77-.39,6,4.24,3.85.4,1.67,9.61,1.11,9.7-1.4,2.09,5.43,4.71,5.08,4.71,5.08s-2.72,6,1.18,6.78c0,3.39,2.45,6.36,5,5.85,2.83-.58,1.93-5.37,1.93-5.37,5.16-2.29,1.69-7.48,1.69-7.48C356.75,140.85,344.77,128.13,334.3,134.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,157.16a3.57,3.57,0,0,1-2.84-1.83,9.43,9.43,0,0,1-1.42-4.6,9.31,9.31,0,0,1,.83-4.73,3.06,3.06,0,0,1,5.74-.37,9.43,9.43,0,0,1,1.43,4.59h0c.23,3.68-1.37,6.79-3.58,6.93Zm-.53-12.82h-.12a3,3,0,0,0-2.3,1.89,9.72,9.72,0,0,0,.56,8.78,3,3,0,0,0,2.52,1.59c1.91-.12,3.28-3,3.07-6.35a8.93,8.93,0,0,0-1.34-4.33A3,3,0,0,0,327.47,144.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.55,156.55a4.17,4.17,0,0,1-3.24-1.79,8.26,8.26,0,0,1-1.64-4.6c-.24-3.67,1.67-6.8,4.25-7s4.87,2.7,5.1,6.38a8.22,8.22,0,0,1-1,4.77,4.1,4.1,0,0,1-3.21,2.2Zm-.41-12.82H337c-2.28.15-4,3-3.75,6.4a7.89,7.89,0,0,0,1.52,4.3,3.27,3.27,0,0,0,5.79-.37,7.75,7.75,0,0,0,1-4.46C341.27,146.31,339.34,143.73,337.14,143.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.47,150.51a.27.27,0,0,1-.18-.47,1.64,1.64,0,0,1,1.77-.14.28.28,0,0,1,.12.37.27.27,0,0,1-.36.12,1.11,1.11,0,0,0-1.18.06A.27.27,0,0,1,331.47,150.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.56,151.25h-.06c-5.82-1.31-7.66-1-7.67-1a.27.27,0,0,1-.12-.53c.08,0,1.93-.38,7.91,1a.26.26,0,0,1,.2.32A.27.27,0,0,1,349.56,151.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.61,154.12a8.44,8.44,0,0,1-4.05,4.49c-2.36,1.11-3.68-1.18-3.14-3.88.49-2.42,2.3-5.92,4.73-5.9S354.6,151.63,353.61,154.12Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.81,150.51c.05.7-.28,1.31-.74,1.35s-.86-.49-.91-1.2.27-1.31.73-1.35S336.75,149.8,336.81,150.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.65,151.13c.05.7-.28,1.31-.73,1.35s-.87-.49-.92-1.2.27-1.31.73-1.35S328.6,150.42,328.65,151.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.09,150.72a60.4,60.4,0,0,0-3.24,6.16c1.25,1.12,3.69.3,3.69.3Z",
    style: {
      fill: "#a02724"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.36,160.81a5.89,5.89,0,0,0,4.05-2.18.22.22,0,0,0-.05-.29.19.19,0,0,0-.28,0,5.64,5.64,0,0,1-4.61,2,.21.21,0,0,0-.22.2.2.2,0,0,0,.2.21A6.81,6.81,0,0,0,333.36,160.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,147.88a.46.46,0,0,0,.18-.1.42.42,0,0,0,0-.59,3.94,3.94,0,0,0-3.46-1.39.41.41,0,0,0,.12.82h0a3.17,3.17,0,0,1,2.72,1.13A.41.41,0,0,0,340,147.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.28,148.35a.43.43,0,0,0,.36-.15,3.28,3.28,0,0,1,2.68-1.32.43.43,0,0,0,.46-.37.42.42,0,0,0-.36-.46,4.14,4.14,0,0,0-3.41,1.63.42.42,0,0,0,.05.58A.33.33,0,0,0,325.28,148.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.53,184.92l-8.62,1.57.78-10.51s8-.47,9.08,3.76Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.19,181.33l.89-3.62a3,3,0,0,1,3.21-2.22l4.4.49-.78,10.51-5.43-1.38A3.15,3.15,0,0,1,265.19,181.33Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.5,134.46c1.73-4.83,4.65-7.94,7.32-8.33,1.79-.25,9.24,1,12.47,2.68s7.91,7.76,8.15,10-2.65,7.83-2.65,7.83S343.82,138.19,331.5,134.46Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.71,128a77.37,77.37,0,0,1,9.28,2.7c.45.18.6.57.34.9-.51.65-1.53,2-2.22,3a1.33,1.33,0,0,1-1.48.36c-2.27-.84-6.17-2.11-8.78-2.82-.47-.13-.69-.47-.55-.81a10,10,0,0,1,2.2-3.07A1.41,1.41,0,0,1,335.71,128Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.58,133.58c9.62,0,13.13,6.33,18.11,8.18s13.17.92,13.17.92S339.16,131.78,324.58,133.58Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.54,
    y: 148.45,
    width: 75.14,
    height: 31.39,
    transform: "translate(544.5 294.5) rotate(172.9)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.76,
    y: 146.82,
    width: 48.83,
    height: 31.39,
    transform: "translate(570.31 289.64) rotate(172.9)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.46,173.85l-1.1-8.81,9.55-1.19,1.09,8.81Zm0-8,.87,6.92,7.65-.95-.86-6.93Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.11,175.27l-1.1-8.81,9.54-1.19,1.1,8.81Zm0-8,.86,6.92,7.66-.95-.86-6.92Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.63,
    y: 146.91,
    width: 10.3,
    height: 8.98,
    transform: "translate(566.18 267.66) rotate(172.9)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.57,
    y: 151.55,
    width: 5.87,
    height: 8.98,
    transform: "translate(492.47 281.53) rotate(172.9)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381,164.41h0c-4.56-.59-11.78-3.54-15.14-6.19a.27.27,0,1,1,.34-.42c3.3,2.6,10.38,5.5,14.87,6.07a.27.27,0,0,1,.23.31A.26.26,0,0,1,381,164.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.41,231.19a.19.19,0,0,1-.1,0c-4.26-1.73-10.48-6.43-13.05-9.85a.28.28,0,0,1,.44-.33c2.52,3.36,8.63,8,12.82,9.68a.28.28,0,0,1,.14.36A.27.27,0,0,1,314.41,231.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.52,172.18a48,48,0,0,1-12.65-2.25.27.27,0,1,1,.16-.52c2.58.79,9.14,2.59,14.08,2.16a.27.27,0,0,1,.3.24.28.28,0,0,1-.25.3C390.63,172.15,390.08,172.18,389.52,172.18Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-130"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.43,129.11c-8.33,9.64,3.45,17.51,5.75,25.63s.94,25.61,11.27,35.61c16.08,15.6,34.63,6.81,37.79-2.31s2-23.44-11.67-33.3c-8.17-5.88-1.78-25.33-9.31-27.66C185.79,115.35,148.84,106.84,150.43,129.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205,187.26a.26.26,0,0,1-.22-.12.27.27,0,0,1,.08-.36c2.67-1.72,4.1-4.78,4-8.61-.12-6.26-4.57-15.14-14.24-20.88-4.37-2.59-4.82-10.32-5.23-17.14-.31-5.37-.61-10.45-2.71-12.19a3,3,0,0,0-2.36-.62.26.26,0,0,1-.3-.23.27.27,0,0,1,.23-.29,3.56,3.56,0,0,1,2.77.73c2.26,1.89,2.57,7.08,2.89,12.57.4,6.69.85,14.27,5,16.72,8.66,5.14,14.35,13.51,14.49,21.32.08,4-1.44,7.24-4.27,9.06A.23.23,0,0,1,205,187.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.48,196.7l-3.18,1.52-7.67-1.68a4.08,4.08,0,0,1-2.25-1.37l-1.68-2a2.49,2.49,0,0,1,0-3.19l1.75-2.06a2.48,2.48,0,0,1,3.45-.33l4.24,3.4S131.27,192.61,131.48,196.7Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.86 410.67 152.83 410.68 151.81 387.99 161.97 388.24 158.86 410.67",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.36,214.88s-.53,63-1.86,90.38a20,20,0,0,0,0,2.45c2,27.47,5.28,80.28,5.28,80.28l10.23.26s8.92-42.17,3.39-80.37c8.87-43.2,13.66-81.75,5.62-93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.8,384.81a62.73,62.73,0,0,0,.69,6.83.54.54,0,0,0,.33.36c4.76,1.86,9.52,1.57,9.91.66s1.21-5.74,1.54-7.57a.53.53,0,0,0-.56-.63c-2,.11-8,.37-11.29-.21A.53.53,0,0,0,150.8,384.81Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.5,239.89c-3.1,10.52-.08,44.31,1.54,59.91,2.21-11.27,4.09-22.11,5.48-32.1Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.15,407.74H160a.64.64,0,0,1,.67.58l.79,6.43a1.48,1.48,0,0,1-1.49,1.53c-3.45-.06-5.11-.25-9.47-.25-2.68,0-4.31.28-8,.28s-3.71-3.55-2.15-3.87c7-1.46,7.89-2.26,10.32-4.16A2.41,2.41,0,0,1,152.15,407.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.33,163.49a4.39,4.39,0,0,0-5.19,3.37v0c-.84,3.92-1.75,7.93-2.69,11.87s-2,7.86-3.16,11.64c-.59,1.88-1.23,3.73-1.94,5.45a23.32,23.32,0,0,1-1.12,2.34c-.06.09-.11.19-.17.29a18,18,0,0,1-2-1c-1.55-1-3.21-2.16-4.78-3.31l-.11-.08a2.2,2.2,0,0,0-3.21,2.87,27.22,27.22,0,0,0,4,5.45,17.13,17.13,0,0,0,2.84,2.45,10,10,0,0,0,2.1,1.06,6.39,6.39,0,0,0,3.46.29,5.85,5.85,0,0,0,2.14-.91,6.84,6.84,0,0,0,.85-.72,2.89,2.89,0,0,0,.24-.27l.19-.22a15,15,0,0,0,1.24-1.69,28.72,28.72,0,0,0,1.74-3.16c1-2.06,1.77-4.09,2.5-6.12,1.45-4.06,2.58-8.13,3.66-12.2.55-2,1-4.08,1.48-6.13s.91-4.08,1.29-6.2A4.38,4.38,0,0,0,151.33,163.49Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.23,206.33c0,2.58,40.06,3.08,40.06-.32l-20.47-5.22-19.59,5.54",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.59,161.8a91.29,91.29,0,0,1,31.88.32,4.57,4.57,0,0,1,3.75,5.51c-5.66,25.37-5.34,33.89-4.79,47.25H148.37c-1.76-22.28-2.68-35-2.92-42.22C145.27,167.16,147.14,162.61,152.59,161.8Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.37,169.17a27.25,27.25,0,0,0,1.38,10.45c.44-2.41,1-5,1.56-7.83Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,143.28c-1,5.08-2,14.38,1.56,17.77,0,0-1.39,5.15-10.82,5.15-10.37,0-5-5.15-5-5.15,5.66-1.35,5.52-5.55,4.53-9.5Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169,146.66l-5.73,4.89a16.25,16.25,0,0,1,.48,2.8c2.17-.31,5.14-2.69,5.37-4.95A7.78,7.78,0,0,0,169,146.66Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.54,136.76c2.46,8.12,3.33,11.62,8.5,14.86,7.78,4.88,17.22.07,17.24-8.62,0-7.83-4-19.81-12.88-21.17A11.58,11.58,0,0,0,154.54,136.76Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.43,142.41c3.95.29,5.63-6.06,3.71-9.56S150.15,136.43,155.43,142.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.27,128.29c12.48,6.7,20-5.84,26.54.82C176.6,119.84,158.94,115.88,153.27,128.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.37,142a66.37,66.37,0,0,0-10.23-1.1c.81,1.89,2.4,3.5,6.27,3.69S175.37,142,175.37,142Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.15 395.72 212.1 397.57 203.27 379.07 212.58 376.52 218.15 395.72",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.79,397l6.62-4a.61.61,0,0,1,.79.12l4.45,5.18a1.17,1.17,0,0,1-.29,1.75c-2.51,1.46-3,1.68-6.11,3.69-1.88,1.23-4.52,4.56-7.12,6.27s-4.38-.64-3.61-1.74a25,25,0,0,0,4.5-10.19A1.66,1.66,0,0,1,210.79,397Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158,214.88s12.89,65.91,17.75,92c5.05,27.14,27.54,72.18,27.54,72.18l9.33-2.56s-12.78-48.14-18.74-72c-1.16-43.2.22-78.39-10.43-89.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,374.1a63.36,63.36,0,0,0,3.23,6,.59.59,0,0,0,.45.21c5.1-.09,9.4-2.16,9.41-3.15,0-.83-1.06-5.78-1.45-7.59a.53.53,0,0,0-.76-.37c-1.81.86-7.22,3.37-10.52,4.09A.53.53,0,0,0,200,374.1Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.21,135.82c.16.68.65,1.13,1.09,1s.66-.73.5-1.4-.64-1.13-1.08-1S168.05,135.15,168.21,135.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.8,134c.16.67.65,1.13,1.09,1s.66-.73.5-1.41-.64-1.13-1.08-1S175.64,133.35,175.8,134Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.12,132.7l1.5-.85S177.1,133.31,176.12,132.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.75,135.79a18.11,18.11,0,0,0,3.41,3.71,3,3,0,0,1-2.29,1Z",
    style: {
      fill: "#ff5652"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.81,143.94a6.24,6.24,0,0,0,3.95,2.63c2.14.4,3-1.55,2.27-3.48-.68-1.72-2.6-4-4.67-3.55A2.78,2.78,0,0,0,153.81,143.94Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.38,128.29c3.92-5.91,9.32-2,10.28-.66s-9.7,11.73-5.14,21.78C152.12,146.66,147.76,137.17,152.38,128.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.08,135.18a.39.39,0,0,0,.32-.35c.17-1.87,2.26-3.09,2.28-3.1a.41.41,0,0,0,.15-.55.4.4,0,0,0-.55-.15c-.11.06-2.48,1.44-2.69,3.72a.4.4,0,0,0,.37.44A.25.25,0,0,0,165.08,135.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.9,129.92a.4.4,0,0,0,.3-.72,4,4,0,0,0-3.62-.76.39.39,0,0,0-.25.52.4.4,0,0,0,.51.25h0a3.2,3.2,0,0,1,2.86.63A.5.5,0,0,0,177.9,129.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.9,191.85c0-.26-.05-.54-.1-.83l-.08-.44-.07-.3c-.1-.36-.19-.75-.3-1.08a42,42,0,0,0-3.09-7.23c-1.14-2.22-2.39-4.33-3.68-6.4-2.57-4.16-5.27-8.1-8.24-12a4.38,4.38,0,0,0-7,5.21l0,.05c2.67,3.72,5.39,7.57,7.94,11.39,1.26,1.93,2.48,3.87,3.63,5.8a41.9,41.9,0,0,1,2.86,5.67c.1.22.15.42.22.62l.05.13h0s0,0,0,.06a2.64,2.64,0,0,1,0,.83,13.91,13.91,0,0,1-.63,2.72,51.21,51.21,0,0,1-2.52,6.1c-1,2.06-2,4.12-3.16,6.15s-2.27,4.1-3.41,6.11l0,0a2.18,2.18,0,0,0,3.51,2.54,93.5,93.5,0,0,0,8.89-11.6,47.68,47.68,0,0,0,3.64-6.72,21,21,0,0,0,1.33-4.1A11.29,11.29,0,0,0,202.9,191.85Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.53,134.5l1.51-.85S169.51,135.11,168.53,134.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.43,170.16a59.54,59.54,0,0,1,2.49-7.74,32.43,32.43,0,0,1,4.91-1A35.9,35.9,0,0,1,162,172c4.49-4.53,13.06-9.11,18.29-10.79a14,14,0,0,1,5.27.66c-3.56,11.24-7.19,22.56-.75,25.46-.11,5.34.2,12,.46,18.66-6.09-.66-30.25-1.82-40.06.32-.5-6.79-.69-12.57-.65-17.5C140,183,144.54,175.07,146.43,170.16Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.71,167.12c-1.12-.5-2.32-1.07-3.54-1.72l-.54.3c1.34.72,2.65,1.35,3.86,1.9.88.4,1.77.79,2.67,1.18,1.87.82,3.75,1.66,5.59,2.57.05-.17.09-.34.14-.52-1.82-.89-3.68-1.72-5.52-2.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.67,184.43c-2.95-2-6-4.12-9.07-6.05a44.92,44.92,0,0,0-12.2-5.73l-.21.49a44,44,0,0,1,12.13,5.69c3.06,1.92,6.11,4,9.05,6,5.9,4,12,8.22,18.55,11.31,0-.2,0-.39,0-.58C178.46,192.53,172.48,188.42,166.67,184.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.81,189.74v-.57l-.91-.39c-13-5.61-26.5-11.41-36.76-21.19-.06.19-.11.38-.17.57,10.31,9.73,23.73,15.51,36.72,21.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.72,170.48c3.81,2.48,7.71,5,11.73,7.33,0-.19.05-.37.07-.56-3.94-2.29-7.77-4.77-11.51-7.21l-3.09-2-.46.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.91,197a37.84,37.84,0,0,1-9.34-6.38c0,.24,0,.49,0,.73a39,39,0,0,0,9.1,6.12c2.68,1.34,5.49,2.5,8.21,3.63,3,1.24,6.11,2.54,9.05,4.08l1.18,0a102.71,102.71,0,0,0-10-4.6C159.38,199.52,156.57,198.36,153.91,197Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.66,205.29a33.24,33.24,0,0,1-9.9-6.91c0,.27,0,.54,0,.81a33.68,33.68,0,0,0,8.81,6.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.38,197.12c-4.47-2.3-9.23-4.21-13.83-6.05-7.4-3-15.05-6-21.56-10.78a26.94,26.94,0,0,1-3.42-2.9c-.06.19-.13.38-.18.57a26.78,26.78,0,0,0,3.29,2.75c6.57,4.79,14.25,7.87,21.68,10.84,4.59,1.84,9.34,3.74,13.78,6a28.09,28.09,0,0,1,2.89,1.69l0-.64A29.7,29.7,0,0,0,182.38,197.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.05,194c-4.63-3.15-9.42-6.41-14.36-9.23a17.4,17.4,0,0,0-2.07-1c0,.19,0,.39.06.58.6.27,1.19.59,1.75.91,4.92,2.81,9.7,6.07,14.32,9.21a178.29,178.29,0,0,0,17.65,11l1.25.06A168.65,168.65,0,0,1,159.05,194Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.07,213.4,187.84,212l-7.61,2a4.12,4.12,0,0,0-2.2,1.45l-1.6,2.09a2.49,2.49,0,0,0,.13,3.2l1.82,2a2.49,2.49,0,0,0,3.46.22l4.13-3.55S190.92,217,191.07,213.4Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,212.17c.13,1.76,1.19,4.74,2.76,6,.88-.28,1.62-1.66,1.62-1.66a10.06,10.06,0,0,1-2.93-6A3.94,3.94,0,0,0,186,212.17Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.26,195.52c.89-3.52-2.58-5.15-4.12-9.47-.57-1.6-1.66-.79-1.73.95a17.67,17.67,0,0,0,1.34,6.1Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.81,193l-5.8,1.22a1.57,1.57,0,0,1-1.63-.82l-6.95-13.84a.85.85,0,0,1,.58-1.28l5.8-1.21a1.56,1.56,0,0,1,1.63.81l6.95,13.84A.84.84,0,0,1,128.81,193Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.7,174.32h0a.25.25,0,0,1-.24-.28l.15-2a.26.26,0,0,1,.28-.24.27.27,0,0,1,.24.28l-.15,2A.26.26,0,0,1,121.7,174.32Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.72,175.09a.27.27,0,0,1-.18-.08.27.27,0,0,1,0-.37l3.52-3.52a.27.27,0,0,1,.37,0,.25.25,0,0,1,0,.37L123.91,175A.27.27,0,0,1,123.72,175.09Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.51,177.11a.27.27,0,0,1-.26-.21.26.26,0,0,1,.21-.3l3.63-.76a.26.26,0,0,1,.11.51l-3.64.76Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.17,193.93l-5.79,1.22a1.59,1.59,0,0,1-1.64-.81L113.8,180.5a.84.84,0,0,1,.58-1.28l5.79-1.22a1.59,1.59,0,0,1,1.64.81l6.95,13.84A.85.85,0,0,1,128.17,193.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.73,189.94l1.14-1.36a1.48,1.48,0,0,1,2.4.16l2,3.12a4,4,0,0,1,.05,4.25l-.17.28Z",
    style: {
      fill: "#ff8b7b"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-130"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.24,98.27l-.87-.56A42.85,42.85,0,0,1,75.48,84.08L76,85A42,42,0,0,0,62.24,98.27Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.29,113.61l-1-.18a41.55,41.55,0,0,1,2.57-8.94l1,.39A41.47,41.47,0,0,0,56.29,113.61Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.85,120.59A38.81,38.81,0,1,0,102.17,159l13.69,10.3,3-16.68A38.73,38.73,0,0,0,135.85,120.59Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.15,133.11a.64.64,0,0,1-.62-.47l-6.88-23.39a.67.67,0,0,1,.09-.55.64.64,0,0,1,.48-.28L114,105.25a.63.63,0,0,1,.51.18.65.65,0,0,1,.2.51l-1.59,24.16a.66.66,0,0,1-.59.61L86.21,133.1Zm-6-23.47,6.5,22.12,25.25-2.3,1.5-22.85Zm32.36,20.42h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.28,109.71a.64.64,0,0,1-.52-.26L76,105.7l-5.38.49a.66.66,0,0,1-.71-.59.66.66,0,0,1,.59-.71l5.75-.52a.67.67,0,0,1,.58.26l3,4.05a.64.64,0,0,1-.14.9A.6.6,0,0,1,79.28,109.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.61,142.7a3.27,3.27,0,1,1,3.26-3.57h0a3.26,3.26,0,0,1-3,3.55Zm0-5.25h-.18a2,2,0,1,0,2.14,1.79h0A2,2,0,0,0,90.62,137.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.4,141.08a3.26,3.26,0,0,1-2.09-.76,3.29,3.29,0,0,1-.42-4.61,3.27,3.27,0,0,1,5.77,1.8h0a3.27,3.27,0,0,1-3,3.55Zm0-5.25h-.18a2,2,0,0,0-1.08,3.48,1.94,1.94,0,0,0,1.44.45,2,2,0,0,0,1.79-2.14h0A2,2,0,0,0,108.4,135.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.92,126.16a1.61,1.61,0,0,1-1-.37l-5.67-4.72a1.6,1.6,0,0,1,2-2.46l4.44,3.69,9.14-11a1.6,1.6,0,0,1,2.47,2L97.15,125.59A1.59,1.59,0,0,1,95.92,126.16Z",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClient);
export default __webpack_public_path__ + "static/media/client.f6ad42a3aaa91b1617ea74367b916906.svg";
export { ForwardRef as ReactComponent };